import { Footer } from '@/previewThemes/bold/Footer';
import { Header } from '@/previewThemes/bold/Header';
import { Product } from '@/previewThemes/bold/Product';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    grid: 'grid-cols-2 gap-4 lg:grid-cols-3',
    filters: 'chips',
    columns: 3,
    // The name on the picture, heavy and uppercase - this theme puts nothing
    // in a quiet caption band.
    card: 'overlay',
  },
  // A filled panel, like the base theme: a hairline box disappears against
  // this theme's blocks of colour, so the one place it differs is the facet
  // rail, which the base leaves unboxed entirely.
  search: {
    results: 'grid grid-cols-2 gap-4 lg:grid-cols-3',
    columns: 3,
    card: 'overlay',
    panel: 'filled',
  },
  blog: { list: 'grid gap-6 sm:grid-cols-2', title: 'text-2xl' },
  category: { grid: 'grid gap-4 sm:grid-cols-2 lg:grid-cols-3', tile: 'overlay' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-4xl sm:text-5xl' },
        gallery: { aspect: 'wide', rounded: false },
      },
    },
  },
};
